export default __webpack_public_path__ + "static/media/hippo_NORMAL.e848c983.png";